import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Modal } from "@mui/material";
import Form from "./form";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate, Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import swal from "sweetalert";
import { setAuth } from "../../state/authReducer";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#198484",
    },
  },
});

async function loginUser(credentials) {
  return fetch(process.env.REACT_APP_BACKEND_URL + "/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((res) => res.json())
    .catch((err) => swal("Error", "Please Check Your Connection", "error"));
}

export default function SignIn() {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [cookies, setCookie] = useCookies(["token"]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    setShowModal(false);
  };

  if (cookies["token"] != null) {
    const decoded = jwtDecode(cookies["token"]);
    const jsonData = JSON.parse(decoded.userInfo);
    dispatch(
      setAuth({
        user: jsonData.username,
        role: jsonData.roles.name,
        companyId: jsonData.companies.id,
        userId: jsonData.id,
        first_time:
          jsonData.first_time && jsonData.roles.name !== "Super Admin",
      })
    );
    return <Navigate replace to="/" />;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await loginUser({
      username,
      password,
    });
    if ("token" in response) {
      swal("Success", "SUCESSFULY lOGGED IN", "success", {
        buttons: false,
        timer: 2000,
      })
        .then((value) => {
          setCookie("token", response["token"], {
            expires: new Date(Date.now() + 8 * 60 * 60 * 1000),
          });
          const decoded = jwtDecode(response["token"]);
          const jsonData = JSON.parse(decoded.userInfo);
          if (jsonData.first_time && jsonData.roles.name !== "Super Admin") {
            dispatch(
              setAuth({
                userId: jsonData.id,
                first_time: jsonData.first_time,
              })
            );
            navigate("/changePassword");
            return;
          }
          dispatch(
            setAuth({
              user: jsonData.username,
              role: jsonData.roles.name,
              companyId: jsonData.companies.id,
              userId: jsonData.id,
              first_time:
                jsonData.first_time && jsonData.roles.name !== "Super Admin",
            })
          );
        })
        .catch((err) => console.log(err));
    } else {
      swal("Failed", response.message, "error");
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <video
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          minHeight: "100vh",
          minWidth: "100vw",
          zIndex: -2,
        }}
        autoPlay
        loop
        muted
        src="/assets/backgroundVideo.mp4"
      />
      <Box
        sx={{
          background: "#198484",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.6,
          zIndex: -1,
        }}
      />
      <Modal open={showModal} onClose={handleClose}>
        <Form callBackAfterSubmit={handleClose} />
      </Modal>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          pt: "3rem",
          background: "transparent",
          minWidth: "100vw",
        }}
      >
        <img
          src={"/assets/ZamZamlogowight.webp"}
          alt="ZamZam Logo"
          style={{ height: "100px", width: "400px", marginBottom: "3rem" }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: 650,
            height: "27rem",
            borderRadius: "1.5rem",
            padding: "1rem 4rem",
            background: "#fff",
            opacity: 1,
            mb: "10rem",
          }}
        >
          <Typography component="h3" variant="h5" color={"#000"}>
          ZamZam Online
          </Typography>
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" color={"#000"}>
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              onChange={(e) => setUserName(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Box>
          <Button
            type="submit"
            variant="outlined"
            color="warning"
            sx={{ mb: 2, alignSelf: "flex-end" }}
            onClick={() => setShowModal(true)}
          >
            Reset Password
          </Button>
        </Box>
        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
      </Container>
    </ThemeProvider>
  );
}
